var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.$t('Vendor Charges'))+"\n  ")]},proxy:true}])},[_c('VendorChargesTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }